import { render, staticRenderFns } from "./SpecialList.vue?vue&type=template&id=51a95efe&scoped=true&"
import script from "./SpecialList.vue?vue&type=script&lang=js&"
export * from "./SpecialList.vue?vue&type=script&lang=js&"
import style0 from "./SpecialList.vue?vue&type=style&index=0&id=51a95efe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a95efe",
  null
  
)

export default component.exports